import axios from 'axios'
import { useLocale } from 'hooks/useLocale'
import type {
  LacedAvailableCurrencies,
  LacedAvailableLocales,
  LacedAvailableLocations
} from 'types/localisation'

interface UpdateUserOptions {
  preferredLocale?: LacedAvailableLocales
  preferredCurrency?: LacedAvailableCurrencies
  preferredLocation?: LacedAvailableLocations
  taxIdNumber?: string
}

export const useUpdateUser = () => {
  const { localiseUrl } = useLocale()

  return async ({
    preferredLocale,
    preferredCurrency,
    preferredLocation,
    taxIdNumber
  }: UpdateUserOptions): Promise<void> => {
    const apiUserUrl = localiseUrl('/api/users', { localeAsParam: true })

    const requestData = {
      preferred_locale: preferredLocale,
      preferred_currency: preferredCurrency,
      preferred_location: preferredLocation,
      tax_id_number: taxIdNumber
    }

    // Filter out undefined values
    const filteredData = Object.fromEntries(
      Object.entries(requestData).filter(([_, value]) => value !== undefined)
    )

    await axios.put(apiUserUrl, filteredData)
  }
}
